import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import Avatar from '@deprecated-ui/common/Avatar';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AVATAR_URL } from 'constants/api';
import {
  effects as userEffects,
  selectors as userSelector,
} from 'lib/entities/user';
import {
  effects as companyEffects,
  selectors as companySelector,
} from 'lib/entities/company';
import { handleErrorAvatar } from 'utils/general';
import Image from 'global/Image';
import If from 'global/Common/If';
import {
  MentionSuggestionResult,
  MentionOption,
  TextareaMentions,
} from '../styled';

interface TextareaProps {
  value?: string;
  onChange?: (text: string) => void;
  onSearch?: (text: string, prefix: string) => void;
  isExpand: boolean;
  [key: string]: any;
}

function Textarea({
  value,
  onChange,
  onSearch,
  isExpand,
  ...props
}: TextareaProps) {
  const [searchKeyword, setSearchKeyword] = useState('');
  const [mentionPrefix, setMentionPrefix] = useState('@');
  const [timeInterval, setTimeInterval] = useState(0);

  const dispatch = useDispatch();
  const {
    search: { data: userSearch },
  } = useSelector(userSelector);
  const {
    search: { data: companySearch },
  } = useSelector(companySelector);

  const SEARCH_DATA = {
    '@': {
      data: userSearch,
      dispatch: userEffects.searchUser,
    },
    $: {
      data: companySearch,
      dispatch: companyEffects.getSearchCompany,
    },
  };

  const handleSearch = (keyword, prefix) => {
    setSearchKeyword(keyword);
    setMentionPrefix(prefix);
    const action = SEARCH_DATA[prefix].dispatch;

    if (keyword.length >= 2) {
      if (timeInterval) {
        clearTimeout(timeInterval);
      }

      setTimeInterval(
        window.setTimeout(() => {
          dispatch(action(keyword));
        }, 500),
      );
    }
  };

  const searchResult = useMemo(() => {
    if (searchKeyword.length >= 2) {
      return SEARCH_DATA[mentionPrefix]?.data;
    }
    return [];
  }, [userSearch, companySearch, searchKeyword]);

  useEffect(() => {
    if (isExpand && value.length) {
      setTimeout(() => {
        onChange('');
        onChange(value);
      }, 0);
    }
  }, [isExpand]);

  return (
    <If condition={isExpand}>
      <MentionSuggestionResult id="compose-mention-container" />
      <TextareaMentions
        {...props}
        prefix={['@', '$']}
        value={value}
        onChange={onChange}
        onSearch={handleSearch}
        notFoundContent={null}
        getPopupContainer={() =>
          document.getElementById('compose-mention-container')
        }
        autoFocus
      >
        {searchResult.map(({ id, name, ...data }, index) => (
          <MentionOption
            // eslint-disable-next-line react/no-array-index-key
            key={`${id}-${index}`}
            value={name}
            className="compose-mention-option"
          >
            <Flex align="center">
              {mentionPrefix === '@' && (
                // @ts-expect-error
                <Avatar size="x-small" mr="8px">
                  <Image
                    alt="avatar-user"
                    src={`${AVATAR_URL}/${data.img}`}
                    onError={(e) => handleErrorAvatar(e, name)}
                  />
                </Avatar>
              )}
              {/* @ts-expect-error */}
              <Text mr="8px">
                {mentionPrefix}
                {name}
              </Text>
              <Text>{data.desc}</Text>
            </Flex>
          </MentionOption>
        ))}
      </TextareaMentions>
    </If>
  );
}

export default Textarea;
